import { render, staticRenderFns } from "./pricedow.vue?vue&type=template&id=f1b3a604&scoped=true"
import script from "./pricedow.vue?vue&type=script&lang=js"
export * from "./pricedow.vue?vue&type=script&lang=js"
import style0 from "./pricedow.vue?vue&type=style&index=0&id=f1b3a604&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b3a604",
  null
  
)

export default component.exports